import { IIngredientTypeDTO } from 'business/models/Models';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import { RMModal } from 'components/modal';
import RMTable from 'components/customComponents/Controls/RMTable';
import React, { useCallback, useState } from 'react';
import { useRMDispatch } from 'redux/hooks';
import { addTypes } from 'redux/reducers/ingredientDetailReducer';
import { IStyle } from 'Styles';
import { useGetAllNewTypes } from './hooks';
import RMCustomButton, {
  RMCustomButtonProps,
} from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';

const TYPES_COLUMNS = [{ accessor: 'name', Header: 'Ingredient Type' }];

const AddIngredientTypes = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const dispatch = useRMDispatch();
  const allIngTypeRows = useGetAllNewTypes();

  const handleSelectionChange = (rowIndices) => {
    setSelectedRows([...rowIndices]);
  };

  const handleAddIngredientTypes = useCallback(() => {
    const newTypes = selectedRows.map((i) => allIngTypeRows[i]);
    dispatch(addTypes(newTypes as IIngredientTypeDTO[]));
    setSelectedRows([]);
    setShowModal(false);
  }, [selectedRows, dispatch, allIngTypeRows]);

  const handleAddClick = () => {
    setShowModal(true);
  };

  const handleCancelClick = () => {
    setShowModal(false);
  };

  const addIngredientTypesIcon: RMCustomButtonProps = {
    Icon: <RMSvgIcon name="New" className="w-8 h-8 cursor-pointer" />,
    titleTip: 'Add Ingredient Types',
    onClick: handleAddClick,
  };

  return (
    <>
      <RMCustomButton {...addIngredientTypesIcon} />
      <RMModal
        id="addingredienttypes-modal-main-container"
        showModal={showModal}
        setShowModal={setShowModal}
        onOk={handleAddIngredientTypes}
        body={
          <div
            id="addingredienttypes-modal-wrapper"
            className="flex flex-col w-full h-96"
          >
            <div
              id="addingingredienttypes-modal-table"
              className="basis-full overflow-x-hidden overflow-y-auto"
            >
              <RMTable
                data={[...allIngTypeRows]}
                columns={TYPES_COLUMNS}
                selectedIds={selectedRows}
                onCheckboxSelectionChange={handleSelectionChange}
                mainContainerStyle={styles.tableStyle}
              />
            </div>
          </div>
        }
        heading={'Select Ingredient Type'}
        onCancel={handleCancelClick}
        okButtonText="Save"
      />
    </>
  );
};

const styles: IStyle = {
  tableStyle: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
  },
};

export default AddIngredientTypes;
